import { Card, CardContent, Stack } from "@altimateai/lego";
import { Button } from "@altimateai/lego";
import styles from "./styles.module.scss";
import classnames from "classnames";
import no_resource from "../../assets/images/no_resource.svg";
import { Link } from "react-router-dom";

const NoExperimentation = () => {
  return (
    <div className={styles.no_items}>
      <Card className={styles.card}>
        <CardContent className="al-pt-4">
          <Stack justify="center">
            <div
              className={classnames("al-flex al-flex-col al-items-center p-4", styles.container)}
            >
              <img src={no_resource} alt="No Datasets" className={styles.img} />
              <h2 className="mt-4 mb-4 text-black">No Experimentation Found</h2>
              <p className="text-muted text-center">
                This means either all of your Experimentation validations have passed successfully
                or there are some issues with your insight configuration.
              </p>
              <Link to="/experimentation/new">
                <Button>New Experimentation</Button>
              </Link>
            </div>
          </Stack>
        </CardContent>
      </Card>
    </div>
  );
};

export { NoExperimentation };
